import React, { useState, useMemo, useEffect } from 'react';
import Select from "react-select";
import countryList from 'react-select-country-list';
import { Form, Formik, Field } from 'formik';
import axios from "axios";
import { NotificationManager } from 'react-notifications';
import emailjs from '@emailjs/browser';
import bg_image_1 from "../../images/img/People search-amico.svg";
import favicon from "../../images/favicon.png";
import { Send } from "lucide-react";

const DemandeLoginForm = () => {
  const [value, setValue] = useState('');
  const options = useMemo(() => countryList().getData(), []);
  const [ip, setIp] = useState({});

  useEffect(() => {
    axios.get('https://ipapi.co/json')
      .then(resp => setIp(resp.data))
      .catch(error => console.log(error));
  }, []);

  const changeHandler = value => {
    setValue(value);
  }

  return (
    <Formik
      initialValues={{
        name: '',
        email: '',
        objet: '',
        phone: '',
        description: '',
        post: '',
        priorisation: '',
        site: '',
        prenom: '',
        pays: '',
        adresse: ''
      }}
      onSubmit={(values, { resetForm }) => {
        const formData = new FormData();
        Object.keys(values).forEach(key => formData.append(key, values[key]));

        axios.post('demand_logins', formData)
          .then(resp => {
            if (resp.status === 201) {

              // Notification par email - email de bienvenue
              const user_email = {};
              user_email['user_email'] = values.email;
              axios.post('/demandelogin', user_email);

              NotificationManager.success('Votre demande est bien envoyée', 'Envoyer', 4000);
              resetForm();
              window.location.replace('/cvtheque');
            } else {
              NotificationManager.warning('Une erreur est survenue lors de l\'envoi de votre demande', 'Erreur', 4000);
            }
          })
          .catch(error => console.log(error));

        const templateParams = {
          email: values.email,
        };
      }}
    >
      <Form>
        <div className="row mb-3">
          <div className="col-sm-6">
            <label htmlFor="name" className="form-label">Nom <span style={{ color: "red" }}>*</span></label>
            <Field name="name" placeholder="Votre nom" type="text" className="form-control h38" required />
          </div>
          <div className="col-sm-6">
            <label htmlFor="prenom" className="form-label">Prénom <span style={{ color: "red" }}>*</span></label>
            <Field name="prenom" placeholder="Votre prénom" type="text" className="form-control h38" required />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-6">
            <label htmlFor="email" className="form-label">Adresse E-mail <span style={{ color: "red" }}>*</span></label>
            <Field name="email" placeholder="Votre adresse e-mail" type="email" className="form-control h38" required />
            <div className="form-text">Votre adresse e-mail ne sera pas publiée.</div>
          </div>
          <div className="col-sm-6">
            <label htmlFor="phone" className="form-label">Numéro téléphone <span style={{ color: "red" }}>*</span></label>
            <Field name="numero" defaultValue={ip.country_calling_code} type="text" className="form-control h38" maxLength={15} />
            <div className="form-text">Votre numéro de téléphone ne sera pas publié.</div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-6">
            <label htmlFor="societe" className="form-label">Nom de l'entreprise <span style={{ color: "red" }}>*</span></label>
            <Field name="object" placeholder="Le nom de votre entreprise" type="text" className="form-control h38" required />
          </div>
          <div className="col-sm-6">
            <label htmlFor="site" className="form-label">Site internet <span style={{ color: "red" }}>*</span></label>
            <Field name="site" placeholder="Votre site internet" type="text" className="form-control h38" required />
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="post" className="form-label">Poste <span style={{ color: "red" }}>*</span></label>
          <Field name="post" placeholder="Votre poste" type="text" className="form-control h38" required />
        </div>
        <div className="mb-3">
          <label htmlFor="priorisation" className="form-label">Ordre de priorité <span style={{ color: "red" }}>*</span></label>
          <Field name="priorisation" as="select" className="form-control" required>
            <option value="">-------</option>
            <option value="Immédiat">Immédiat</option>
            <option value="Urgent">Urgent</option>
            <option value="Indéterminé">Indéterminé</option>
          </Field>
        </div>
        <div className="row mb-3">
          <div className="col-sm-6">
            <label htmlFor="adresse" className="form-label">Adresse <span style={{ color: "red" }}>*</span></label>
            <Field name="adresse" placeholder="Votre adresse exacte" type="text" className="form-control h38" required />
          </div>
          <div className="col-sm-6">
            <label htmlFor="pays" className="form-label">Pays <span style={{ color: "red" }}>*</span></label>
            <Select name="pays" options={options} value={value} onChange={changeHandler} required />
            {/* defaultValue={ip.country_name} */}
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">Description de votre demande</label>
          <Field name="description" as="textarea" className="form-control" rows={4} placeholder="Votre description" />
        </div>
        <br />
        <div className="mb-3 form-check">
          <Field type="checkbox" className="form-check-input" id="newsletter" />
          <label className="form-check-label" htmlFor="newsletter">S'inscrire à la newsletter</label>
        </div>
        <button type="submit" className="btn btn-acc"><Send /> Envoyer la demande</button>
      </Form>
    </Formik>
  );
};

class DemandeLogin extends React.Component {
  render() {
    return (
      <>
        <div className="adminx-content adminx-content-acc">
          <div className="adminx-main-content">
            <div className="container-fluid">
              <div className="pb-3 text-center">
                <h2 className="fw-bco">
                  <img
                    src={favicon}
                    className="navbar-brand-image d-inline align-bottom mr-2"
                    alt=""
                  />{" "}
                  CVthèque
                </h2>
                <h3 className="color-b">Devenir un recruteur dans CVthèque</h3>
              </div>

              <div className="row">
                <div className="col-lg-6">
                    <h4>Pourquoi demander un login</h4>
                    <p>
                      <b>Vous cherchez à recruter des talents qualifiés pour votre entreprise ?</b> <br />
                      Ne cherchez plus loin que notre CVthèque. Inscrivez-vous dès maintenant pour découvrir une
                      myriade de profils de candidats qualifiés, spécialisés dans votre secteur d'activité.
                      Que vous cherchiez des employés à temps plein, à temps partiel ou des stagiaires,
                      vous êtes sûr de trouver des candidats passionnés et qualifiés pour l'emploi.
                      Inscrivez-vous dès maintenant pour accéder à notre base de données de CV et découvrir
                      les talents qui peuvent faire la différence pour votre entreprise !
                      <hr />
                    </p>
                    <div className='col-md-10'>
                        <img src={bg_image_1} alt="activ solution" className='img-fluid' />
                    </div>
                  </div>

                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-header-title">Votre demande</div>
                    </div>
                    <div className="card-body">
                      <DemandeLoginForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default DemandeLogin;
